module.exports = __webpack_public_path__ + "media/images/sec_7-52ee9bde276b0454ce030b98a32b736f.png";